export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-350px.jpg.64a857e8.webp";